import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "./SupplierImport.scss";

import {
  BsQuestionCircle
} from "react-icons/bs";
import { ScaleLoader } from "react-spinners";
import { LOADER_COLOR } from "../../../core/constants/common";
import ImportService from "../../../core/service/ImportService";
function ImportStart({ t, param, callbackStart }) {
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState(LOADER_COLOR);
  const handleContinueStart = () => {

    let obj = {
      type: "Continue",
    };
    setLoading(true);
    ImportService.importStageData(param)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          callbackStart(obj);
        }

      })
      .catch((error) => {
        // console.log(error);
        // toast.error(error.response.data.title, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .finally(() => {
        setLoading(false);
      });

  };
  const handleBack = () => {
    let obj = {
      type: "Back"
    };
    callbackStart(obj);
  }

  return (
    <>
      {loading && (
        <div className="loader-custom">
          <ScaleLoader color={color} loading={true} size={25} />
        </div>
      )}
      <div className="Start_importCard">
        <div className="Start_importCard_head">
          <h6>
            {t("StartImport.label")}<BsQuestionCircle />
          </h6>
          <p className="m-0">{t("RecordstoImport.label")}</p>
        </div>
        <div className="text-start p-2">
          <button type="button" className="btn btn-secondary me-2 px-4" onClick={handleBack}>
            {t("Back.label")}
          </button>
          <button
            type="button"
            className="btn btn-primary px-4"
            onClick={handleContinueStart}
          >
            {t("StartImport.label")}
          </button>
        </div>

      </div>
    </>
  );
}
export default withTranslation()(ImportStart);
